import { render, staticRenderFns } from "./today_play.vue?vue&type=template&id=32d6fa0a&"
import script from "./today_play.vue?vue&type=script&lang=ts&"
export * from "./today_play.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports